import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-apple-by-purchase',
  templateUrl: './apple-by-purchase.component.html',
  styleUrls: ['./apple-by-purchase.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppleByPurchaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
